export const provider = ['buypower', 'paystack'];

export const disco = [
  'abuja',
  'kaduna',
  'jos',
  'ph',
  'ikeja',
  'eko',
  'ibadan',
  'enugu',
  'kano',
  'bh',
  'accesspower',
  'benin',
  'yola',
  'koios',
  'kaida',
  'sao_energies',
  'darway_coast',
  'buy_power_1',
  'buy_power_2',
  'buy_power_3',
  'kaida_sts',
  'ashipa',
  'maskh',
  'ukniaf',
  'ceneco',
  'buc',
  'enercon',
  'nesco',
  'araromi',
  'gve',
];
